<p-tabView>
  <p-tabPanel header="Notification Configuration" headerStyleClass="iconPanel">
    <p-table [value]="allModules" [rows]="15" [paginator]="true" dataKey="moduleId" [loading]="loading"
      (onLazyLoad)="loadNotification($event)" [lazy]="true">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 2rem;"></th>
          <th>Module</th>
          <th style="width: 300px;">Notification Name</th>
          <th style="width: 300px;">Channel</th>
          <th>Is Active</th>
          <th>Type</th>
          <th>Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-expanded="expanded">
        <tr class="parent-color">
          <td class="action bottom-line">
            <button type="button" pButton pRipple [pRowToggler]="data"
              class="p-button-text p-button-rounded p-button-plain mr-2"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" *ngIf="data.subscription.length > 0">
            </button>
          </td>
          <td [attr.colspan]="7" class="bottom-line">
            <b>{{data.moduleName}}</b>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-data>
        @for(s of data.subscription; track s){
        @if(s.isActive){
        <tr>
          <td colspan="2"></td>
          <td>
            {{s.eventName}}
          </td>
          <td>
            @for(c of s.channels; track c; let i = $index){
            {{c.channelName}}@if (s.channels.length > 1 && i !== s.channels.length-1) {,}
            }
          </td>
          <td>
            @if (s.isActive) {Yes} @else {No}
          </td>
          <td class="action">
            @if (s.isPushNotification) {
            <span class="p-mr-2" pTooltip="Push Notification" tooltipPosition="top">
              <i class="pi pi-bell"></i>
            </span>
            }
            @if (s.isWhatsApp) {
            <span class="p-mr-2" pTooltip="WhatsApp" tooltipPosition="top">
              <i class="pi pi-comment"></i>
            </span>
            }

            @if (s.isSMS) {
            <span class="p-mr-2" pTooltip="SMS" tooltipPosition="top">
              <i class="pi pi-comments"></i>
            </span>
            }
            @if (s.isEmail) {
            <span pTooltip="E-Mail" tooltipPosition="top">
              <i class="pi pi-envelope"></i>
            </span>
            }
          </td>
          <td class="action">
            <span class="btnBars p-mr-0" (click)="showEditNotificationChannel(s,data)" pTooltip="Edit"
              tooltipPosition="top"><i class="pi pi-pencil"></i></span>
          </td>
        </tr>
        }
        }

      </ng-template>
    </p-table>

  </p-tabPanel>

  <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
    <ng-template pTemplate="header">
      <p-menu #configmenuNotification id="config_menu_notification" [model]="configMenuNotificationItems" [popup]="true"
        appendTo="body"></p-menu>
      <span class="btnBars p-mr-0" (click)="configmenuNotification.toggle($event)">
        <i class="pi pi-bars"></i>
      </span>
    </ng-template>
  </p-tabPanel>
</p-tabView>

<p-dialog header="{{addEditNotificationHeader}}" [(visible)]="displayAddEditNotification" [modal]="true"
  [responsive]="true" [style]="{width: '65vw', height: '65vh'}">
  <div class="header">
    <h5 style="position: relative;">
      {{tempNofiChild.eventName}}
      <p-inputSwitch class="header-switch" [(ngModel)]="tempNofiChild.isActive"></p-inputSwitch>
    </h5>
  </div>
  <div class="card">
    <div class="p-grid">
      @if(tempNofi?.moduleId !== workSpaceModuleId){
      <div class="p-col-12">
        <label for="channelname">{{tempNofi?.moduleName}} Channel Name</label>
        <p-multiSelect appendTo="body" optionLabel="channelname" [options]="allChannels"
          [(ngModel)]="selectedChannel"></p-multiSelect>
      </div>
      }
    </div>

    <div class="p-grid">
      <div class="p-col-12">
        <label for="notificationType">{{'Configuration.System.Notitfication_Type' | transloco}} <span
            style="color: red; font-size: 16px;">*</span></label>
        <p-checkbox binary="true" [(ngModel)]="tempNofiChild.isPushNotification" inputId="push"
          label="{{'Configuration.System.Push_Notification' | transloco}}"></p-checkbox>
        <!-- Localization for whatsapp, sms and email not need because of same translated value-->
        &nbsp;&nbsp;<p-checkbox binary="true" [(ngModel)]="tempNofiChild.isWhatsApp" inputId="wa" label="WhatsApp">
        </p-checkbox>
        &nbsp;&nbsp;<p-checkbox binary="true" [(ngModel)]="tempNofiChild.isSMS" inputId="sms" label="SMS">
        </p-checkbox>
        &nbsp;&nbsp;<p-checkbox binary="true" [(ngModel)]="tempNofiChild.isEmail"
          (onChange)="onEmailCheckboxChange($event)" inputId="email" label="E-Mail">
        </p-checkbox>
        <!--  #region show email details  only for workspace module  -->
        @if(tempNofi?.moduleId === workSpaceModuleId && tempNofiChild.isEmail && tempNofiChild.emailPreference){
        <p-panel [toggleable]="true" [class.child-panel]="'true'" class="w-100 border-shadow">
          <ng-template pTemplate="header">
            <div class="p-grid w-100">
              <div class="p-d-flex p-col-12 p-ai-center p-jc-between">
                <div><strong>Email Digest</strong></div>
                <!-- Edit and Delete icons on the right side -->
                <div class="p-d-flex">
                  <button pButton icon="pi pi-pencil" class="p-button-text p-button-rounded p-mr-2"
                    (click)="openEmailPreferenceDialog()"></button>
                  <button pButton icon="pi pi-trash" class="p-button-text p-button-rounded p-button-danger"
                    (click)="onDeleteClick()"></button>
                </div>
              </div>
            </div>
          </ng-template>

          <ng-container>
            <div class="activity-card">
              <div class="p-grid">
                <!-- Only showing the relevant information based on requirements -->
                <div class="p-col-12">
                  <div class="p-grid">
                    <div class="p-col-2">
                      <p><strong>Email Prefrence:</strong></p>
                    </div>
                    <div class="p-col-10">
                      <p-tag [value]="getEmailPreferenceLabel()" [severity]="getSeverity()">
                      </p-tag>
                      <span *ngIf="tempNofiChild.emailPreference === 'dailySummaryEmail'" class="p-ml-2">
                        at {{ timePreference }}
                      </span>
                    </div>
                  </div>

                  <!-- Different content based on email preference -->
                  <div class="p-grid" *ngIf="tempNofiChild.emailPreference  === 'immediateEmail'">
                    <div class="p-col-2">
                      <p><strong>Details:</strong></p>
                    </div>
                    <div class="p-col-10">
                      <span class="task-details">
                        You will receive an email immediately when activities occur.
                      </span>
                    </div>
                  </div>

                  <div class="p-grid" *ngIf="emailPreference === 'dailySummaryEmail'">
                    <div class="p-col-2">
                      <p><strong>Details:</strong></p>
                    </div>
                    <div class="p-col-10">
                      <span class="task-details">
                        You will receive a daily summary of all activities at {{ formatTimeDisplay() }}.
                      </span>
                    </div>
                  </div>

                  <!-- Recipient information -->
                  <!-- <div class="p-grid task-details-wrapper p-mt-3">
                          <div class="p-col-4">
                            <p><i class="pi pi-user p-mr-1"></i><strong>Recipient: </strong></p>
                          </div>
                          <div class="p-col-8">
                            <p>
                              Vishal
                            </p>
                          </div>
                        </div> -->
                </div>
              </div>
            </div>
          </ng-container>
        </p-panel>
        }
        <!--  #endregion show email details  only for workspace module  -->
      </div>
    </div>
  </div>
  <p-footer>
    <button type="button" pButton (click)="displayAddEditNotification=false"
      label="{{'Configuration.System.Cancel' | transloco}}" class="p-button-secondary"></button>
    <button type="button" pButton (click)="validateAndSaveNotification()"
      label="{{'Configuration.System.Save' | transloco}}"></button>
  </p-footer>
</p-dialog>

<!-- Email Preference Dialog For WorkSpace -->
@if(tempNofi?.moduleId === workSpaceModuleId && displayEmailPreferenceDialog){
<p-dialog header="Email Notification Settings" [(visible)]="displayEmailPreferenceDialog" [modal]="true"
  [style]="{width: '50vw'}" [closable]="false" [draggable]="false" [responsive]="true">
  <div class="p-fluid">
    <!-- Email Preference Selection -->
    <div class="p-field p-mb-4">
      <label for="emailPreference">Email Notification Preference <span style="color: red;">*</span></label>
      <p-dropdown id="emailPreference" [options]="emailOptions" [(ngModel)]="tempNofiChild.emailPreference"
        placeholder="Select Email Option" (onChange)="onEmailPreferenceChange()" [style]="{'width':'100%'}"
        optionLabel="label" optionValue="value" appendTo="body">
      </p-dropdown>
      <small class="p-error" *ngIf="isSubmitted && !tempNofiChild.emailPreference">
        Please select an email preference
      </small>
    </div>

    <!-- Time Selection (Only for Daily Summary) -->
    @if(tempNofiChild.emailPreference === 'dailySummaryEmail'){
    <div class="p-field p-mb-4">
      <label>Delivery Time<span style="color: red;">*</span></label>

      <div class="p-inputgroup time-input-group">
        <!-- Hour -->
        <span class="p-inputgroup-addon time-label">Hour<span style="color: red;">*</span></span>
        <p-dropdown [options]="hourOptions" [(ngModel)]="tempNofiChild.hour" optionLabel="label" optionValue="value"
          appendTo="body" [style]="{'width':'100%'}">
        </p-dropdown>

        <!-- Minutes -->
        <span class="p-inputgroup-addon time-label">Min<span style="color: red;">*</span></span>
        <p-dropdown [options]="minuteOptions" [(ngModel)]="tempNofiChild.minute" optionLabel="label" optionValue="value"
          appendTo="body" [style]="{'width':'100%'}">
        </p-dropdown>

        <!-- Period (AM/PM) -->
        <span class="p-inputgroup-addon time-label">Period<span style="color: red;">*</span></span>
        <p-dropdown [options]="periodOptions" [(ngModel)]="tempNofiChild.period" optionLabel="label" optionValue="value"
          appendTo="body" [style]="{'width':'100%'}">
        </p-dropdown>
      </div>

      <!-- <small class="p-error" *ngIf="emailPreferenceSubmitted && tempEmailPreference === 'dailySummaryEmail' && 
          (!tempHour || !tempMinute || !tempPeriod)">
          Please select a complete delivery time
        </small> -->
    </div>
    }
  </div>

  <p-footer>
    <button type="button" pButton label="Cancel" class="p-button-secondary"
      (click)="cancelEmailPreferenceDialog()"></button>
    <button type="button" pButton label="Apply" (click)="confirmEmailPreferenceDialog()"></button>
  </p-footer>
</p-dialog>
}


<p-dialog header="InActive Subscription Lists" [(visible)]="displayNotificationList" [modal]="true" [responsive]="true"
  [style]="{width: '60vw'}">
  <div class="card">
    <p-table [value]="allModules" selectionMode="multiple" [(selection)]="selectedLists" dataKey="id">
      <ng-template pTemplate="header">
        <tr>
          <th>Module</th>
          <th>Notification Name</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-expanded="expanded">
        <tr class="parent-color">
          <td [attr.colspan]="6" class="bottom-line">
            <b>{{data.moduleName}}</b>
          </td>
        </tr>
        <ng-container *ngFor="let s of data.subscription; let index = index;">
          <tr [pSelectableRow]="s" [pSelectableRowIndex]="index" *ngIf="!s.isActive">
            <td></td>
            <td>
              {{s.eventName}}
            </td>
          </tr>
        </ng-container>
      </ng-template>
    </p-table>
  </div>
  <p-footer>
    <button type="button" pButton (click)="displayNotificationList=false"
      label="{{'Configuration.System.Cancel' | transloco}}" class="p-button-secondary"></button>
    <button type="button" pButton (click)="addNotification()"
      label="{{'Configuration.System.Save' | transloco}}"></button>
  </p-footer>
</p-dialog>